export default __webpack_public_path__ + "static/media/font-shirt.cad35caa.svg";